import { Link } from "react-router-dom";
import { useGetAllQuizeQuery } from "../../../features/quize/quizeApi";
import Quizze from "./Quizze";

export default function Quizzes() {
  const { data: quizzes, isLoading, isError } = useGetAllQuizeQuery() || {};
  // decide what to render
  let content = null;
  if (isLoading)
    content = (
      <tr>
        <td colSpan="3" style={{ textAlign: "center" }}>
          Loading....
        </td>
      </tr>
    );
  if (!isLoading && isError)
    content = (
      <tr>
        <td colSpan="3" style={{ textAlign: "center" }}>
          There was an error
        </td>
      </tr>
    );
  if (!isLoading && !isError && quizzes?.length === 0)
    content = (
      <tr>
        <td colSpan="3" style={{ textAlign: "center" }}>
          No Quizzes found
        </td>
      </tr>
    );
  if (!isLoading && !isError && quizzes?.length > 0) {
    content = quizzes.map((quizze, i) => (
      <Quizze key={i} quizze={quizze} serial={i + 1} />
    ));
  }
  return (
    <div className="px-3 py-20 bg-opacity-10">
      <Link to={"/admin/quizzes/addquize"}>
        <div className="w-full flex">
          <button className="btn ml-auto">Add Quiz</button>
        </div>
      </Link>
      <div className="overflow-x-auto mt-4">
        <table className="divide-y-1 text-base divide-gray-600 w-full">
          <thead>
            <tr>
              <th className="table-th">Question</th>
              <th className="table-th">Video</th>
              <th className="table-th justify-center">Action</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-slate-600/50">{content}</tbody>
        </table>
      </div>
    </div>
  );
}
